import { Pagination } from 'antd';
import Disclaimer from 'components/common/Disclaimer';
import HeaderMeta from 'components/headerMeta/HeaderMeta';
import React, { Component, Fragment } from 'react';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import Footer from '../../components/layout/Footer';
import store from '../../redux/store';
import { getBlogCategoryTags, getBlogList, getSearchBlog } from '../../services/index';
import { roll } from '../../untils/auth';
import BlogList from './components/BlogList';
import BlogNav from './components/BlogNav';

import '../../assets/style/itemStyle/blog.scss';

export default class Blog extends Component {
  state = {
    categoryTags: [], //分类标签数据
    blogList: [], //blog列表数据
    blogSearchList: [], //blog搜索列表数据
    pageSize: 10, //每页条数
    pageCount: 1, //总页数
    total: 1, //总数
    isClick: false, //是否点击过该分类
    searchTagsData: [], //渲染顶部的nav数据 (有搜索)
    tagsData: [], //渲染底部的nav数据 (无搜索)
    isSearchShow: false, //是否搜索
    searchValue: '', //搜索关键词
  };

  //点击获取blog列表
  changeUrlHandle = async (item) => {
    let bannerHeight = 0;
    if (document.querySelector('.banner')) {
      bannerHeight = document.querySelector('.banner').offsetHeight - 64;
    }

    roll(bannerHeight);
    let { isClick } = this.state;
    store.dispatch({
      type: 'clear_keyword',
    });

    // Update URL with query parameter
    if (item) {
      this.props.history.push({
        pathname: '/blog',
        search: `?category=${item.url}`,
        state: { categoryId: item.id },
      });
    } else {
      this.props.history.push({
        pathname: '/blog',
      });
    }

    this.setState({
      isSearchShow: false,
      blogSearchList: [],
      blogList: [],
    });

    // Fetch blog data for the selected category
    if (isClick && item) {
      this.getBlogListDataHandle(item.id);
    } else {
      this.getBlogListDataHandle(item ? item.id : '1');
    }
  };

  //获取blog列表数据
  getBlogListDataHandle = async (categoryId = null) => {
    let firstPage = 1;
    let id = categoryId || this.getCurrentCategory();
    await this.getBlogListData(id, firstPage);
  };

  //获取blog首次加载数据
  getDefaultBlogListData = async () => {
    let tagsList = store.getState().getCategoryTags;
    if (!Object.values(tagsList).length) {
      //获取分类标签接口
      getBlogCategoryTags().then((res) => {
        if (res.code && Object.keys(res.data).length) {
          let { categoryTags } = this.state;
          categoryTags = res.data.info;

          //按照weight排序
          categoryTags.sort((a, b) => {
            return b.weight - a.weight;
          });
          //存tags数据
          store.dispatch({
            type: 'save_tag',
            data: res.data.info,
          });
          this.setState({
            categoryTags,
          });
          this.getDefaultData(categoryTags);
          //动态分类菜单
          this.initNavStyle();
        }
      });
    } else {
      this.setState({
        categoryTags: tagsList,
      });
      this.getDefaultData(tagsList);
    }
  };

  //获取首次加载的数据
  getDefaultData = (list) => {
    let firstPage = 1;
    let id = '1';

    // Get category from URL query
    const searchParams = new URLSearchParams(this.props.location.search);
    const categoryUrl = searchParams.get('category');

    if (categoryUrl) {
      this.setState({
        isClick: true,
      });
      for (let item of list) {
        if (categoryUrl === item.url) {
          id = item.id;
        }
      }
    }

    let keyword = store.getState().getBlogSearchkeyword;
    if (keyword) {
      //获取搜索数据
      let page = 1;
      this.searchBlogList(keyword, page);
      this.setState({
        searchValue: keyword,
      });
    } else {
      //获取分类数据
      this.getBlogListData(id, firstPage);
    }
  };
  //获取博客列表请求
  getBlogListData = (id, page) => {
    getBlogList(id, page).then((res) => {
      if (res.code && Object.keys(res.data).length > 0) {
        let blogList = res.data.info;
        this.setState({
          blogList,
          total: res.data.Records,
          pageCount: res.data.pages,
        });
      } else {
        this.setState({
          blogList: [],
        });
      }
    });
  };
  // 搜索博文列表
  searchBlogList = (value, page) => {
    this.setState({
      searchValue: value,
    });
    getSearchBlog(value, page).then((res) => {
      if (res.code && Object.keys(res.data).length > 0) {
        let blogSearchList = res.data.info;
        this.setState({
          blogSearchList,
          total: res.data.Records,
          pageCount: res.data.pages,
          isSearchShow: true,
        });
      } else {
        this.setState({
          isSearchShow: true,
          blogSearchList: [],
        });
      }
    });
  };
  //改变页码
  changePage = (page, pageSize) => {
    let bannerHeight = 0;
    if (document.querySelector('.banner')) {
      bannerHeight = document.querySelector('.banner').offsetHeight;
    }
    roll(bannerHeight);

    let { isSearchShow, searchValue } = this.state;
    this.setState({
      page: page,
      size: pageSize,
    });
    if (isSearchShow && searchValue) {
      this.searchBlogList(searchValue, page);
    } else {
      // Get category ID from URL query
      const searchParams = new URLSearchParams(this.props.location.search);
      const categoryUrl = searchParams.get('category');
      let categoryId = '1';

      if (categoryUrl) {
        const { categoryTags } = this.state;
        for (let item of categoryTags) {
          if (categoryUrl === item.url) {
            categoryId = item.id;
          }
        }
      }

      this.getBlogListData(categoryId, page);
    }
  };

  //获取当前分类的url和id
  getCurrentCategory = () => {
    // Get category ID from URL query
    const searchParams = new URLSearchParams(this.props.location.search);
    const categoryUrl = searchParams.get('category');
    let id = '1';

    if (categoryUrl) {
      const { categoryTags } = this.state;
      for (let item of categoryTags) {
        if (categoryUrl === item.url) {
          id = item.id;
        }
      }
    }

    return id;
  };
  //动态展示导航样式
  initNavStyle = () => {
    let totalTags = document.getElementById('blogUl')
      ? document.getElementById('blogUl').children
      : [];
    let navWidth = document.getElementById('blogMenu')
      ? document.getElementById('blogMenu').offsetWidth
      : 0;
    let searchWidth = document.getElementById('navSearch')
      ? document.getElementById('navSearch').offsetWidth
      : 0;
    let moreWidth = document.getElementById('navMore')
      ? document.getElementById('navMore').offsetWidth
      : 0;
    let tagAllWidth = document.getElementById('tagAll')
      ? document.getElementById('tagAll').offsetWidth
      : 0;

    //计算除了more和All Posts的宽度
    let tagsWidth = navWidth - moreWidth - tagAllWidth;

    let liWidth = 0;
    let tagsData = {
      tagsArr: [],
      moreArr: [],
    };
    let searchTagsData = {
      tagsArr: [],
      moreArr: [],
    };
    //计算tag的宽度
    for (let item of totalTags) {
      //计算除all和more标签的宽度
      let data = item.getAttribute('data-tag');
      if (data) {
        liWidth += item.offsetWidth;
        //有搜索（减去搜索按钮）
        if (liWidth <= tagsWidth - searchWidth) {
          searchTagsData['tagsArr'].push(JSON.parse(data));
        } else {
          searchTagsData['moreArr'].push(JSON.parse(data));
        }

        //无搜索
        if (liWidth <= tagsWidth) {
          tagsData['tagsArr'].push(JSON.parse(data));
        } else {
          tagsData['moreArr'].push(JSON.parse(data));
        }
      }
    }
    this.setState({
      searchTagsData,
      tagsData,
    });
  };

  async componentDidMount() {
    //获取默认数据
    await this.getDefaultBlogListData();
    //动态展示导航样式
    this.initNavStyle();
    let params = this.props.location.state;
    if (params === undefined || !params?.type) {
      roll(0);
    } else {
      roll(700);
    }
  }

  render() {
    let {
      categoryTags,
      searchTagsData,
      tagsData,
      blogList,
      blogSearchList,
      isSearchShow,
      searchValue,
      pageSize,
      total,
    } = this.state;
    const displayBlogList = isSearchShow ? blogSearchList : blogList;
    return (
      <Fragment>
        <HeaderMeta type="blog" jsonLd={[buildPageBreadcrumb('Blog', '/blog')]} />
        <div className="blog-container">
          {/* banner */}

          <div className="banner">
            <h1>Private Jet Charter Blog</h1>
            <img
              src={require('../../assets/imgs/webp/blog-banner.webp').default}
              alt="Front view of a private jet on a runway during daylight, representing aviation insights and the latest travel news"
            />
          </div>
          <div style={{ marginTop: '16px' }}>
            <Disclaimer />
          </div>

          <div className="blog-content">
            <BlogNav
              option="search"
              history={this.props.history}
              location={this.props.location}
              changeUrlHandle={this.changeUrlHandle}
              categoryTagsData={searchTagsData}
              searchBlogList={this.searchBlogList}
              isSearchShow={isSearchShow}
            />

            {displayBlogList.length > 0 ? (
              <>
                <ul className="blog-category-list category-list">
                  <BlogList
                    searchValue={isSearchShow ? searchValue : ''}
                    blogList={displayBlogList}
                  />
                </ul>
                <Pagination
                  showSizeChanger={false}
                  pageSize={pageSize}
                  total={total}
                  onChange={(page, pageSize) => {
                    this.changePage(page, pageSize);
                  }}
                />
                <BlogNav
                  history={this.props.history}
                  location={this.props.location}
                  categoryTagsData={tagsData}
                  changeUrlHandle={this.changeUrlHandle}
                />
              </>
            ) : (
              <div className="noData">
                <img
                  src={require('../../assets/imgs/webp/blog-noData.webp').default}
                  alt="nodata img"
                />
                <p>
                  {isSearchShow
                    ? 'Not found, change the keyword to try'
                    : 'There are no blogs in this category. See others'}
                </p>
              </div>
            )}
            {/* 用来获取计算nav的宽度 */}
            <div className="blog-menu" id="blogMenu">
              <ul className="blog-category-nav" id="blogUl">
                <li
                  id="tagAll"
                  className={`default ${
                    !new URLSearchParams(this.props.location.search).get('category') ? 'active' : ''
                  }`}
                >
                  <span>All Posts</span>
                </li>
                {categoryTags &&
                  categoryTags.map((item, index) => {
                    return (
                      <li
                        className={`${
                          new URLSearchParams(this.props.location.search).get('category') ===
                          item.url
                            ? 'active'
                            : ''
                        }`}
                        data-tag={JSON.stringify(item)}
                        key={index}
                      >
                        <span>{item.name}</span>
                      </li>
                    );
                  })}
                <li className="more" id="navMore">
                  <span>More</span>
                </li>
              </ul>
              <div className="search" id="navSearch">
                <img
                  src={require('../../assets/imgs/svg/blog-seach-nav.svg').default}
                  alt="search icon"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}
